// Third-party
import React, { ReactNode } from 'react';
import classNames from 'classnames';

// Components
import { PrimaryButton, CancelButton } from '../buttons';
import Modal from '@/views/components/modals/AccessibleModal';

// Utils
import { FormattedMessage } from '../../../utils/i18n';

type Props = {
  className?: string;
  onCancel: () => void;
  onConfirm: () => void;
  show: boolean;
  children: ReactNode;
  confirmIsDisabled?: boolean;
  confirmLabel?: string;
};

const ActionModal = ({ show, onCancel, onConfirm, confirmIsDisabled, children, className, confirmLabel }: Props) => (
  <Modal show={show} onHide={onCancel} className={classNames('action-modal', className)} dialogClassName="modal-dialog-centered">
    <Modal.Body className="d-flex flex-column">{children}</Modal.Body>

    <Modal.Footer className="d-flex flex-column">
      <PrimaryButton className="confirm-button" onClick={onConfirm} disabled={confirmIsDisabled}>
        <span>{confirmLabel || <FormattedMessage id="Common.Done" />}</span>
      </PrimaryButton>

      <CancelButton onClick={onCancel} />
    </Modal.Footer>
  </Modal>
);

export default ActionModal;
